<template>
  <div class="mod-rm__courseclassroomrela">
    <div style="margin-top: 5px">
      <el-row :gutter="10">
        <el-col :span="18">
          <!--添加教室-->
          <el-card class="box-card">
            <!--查询教室-->
            <el-row>
              <el-col :span="24">
                <div ref="queryBox" class="queryBox">
                  <el-form
                    :label-position="labelPosition"
                    :label-width="queryLabelWidth"
                    class="traninerPool-search-condition"
                    :model="dataForm"
                  >
                    <el-row :gutter="0">
                      <el-col :span="7">
                        <!-- 教室编号 -->
                        <el-form-item
                          class="oneBoxTrainer"
                          :label="$t('res.courseclassroomrela.classroom')"
                        >
                          <el-input
                            v-model="dataForm.classroomNo"
                            clearable
                            :placeholder="
                              $t(
                                'res.courseclassroomrela.classroomNamePlaceholder'
                              )
                            "
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="7">
                        <!-- 教室分类 -->
                        <el-form-item
                          prop="classroomClassList"
                          class="oneBoxTrainer"
                          :label="$t('res.courseclassroomrela.classroomClass')"
                        >
                          <class-tree
                            ref="classroomclassRef"
                            v-on:getSelectList="getClassroomList"
                            v-bind:defaultProps="classroomProps"
                            v-bind:url="queryclassroomUrl"
                            v-bind:isSelect="false"
                            style="width: 99%"
                          ></class-tree>
                        </el-form-item>
                      </el-col>
                      <!-- 教室标签 -->
                      <el-col :span="7">
                        <el-form-item
                          style="height: 34px"
                          class="search-item oneBoxTrainerLabel"
                        >
                          <span slot="label">
                            <el-link
                              type="primary"
                              :underline="false"
                              slot="reference"
                              @click.native.prevent="showSuboLableDlg"
                              >{{
                                $t("res.courseclassroomrela.classroomLabel")
                              }}</el-link
                            >
                          </span>
                          <div
                            class="el-input el-input--default el-input__inner"
                            style="height: 30px"
                            @mouseenter="classroomLabelShow()"
                            @mouseleave="classroomLabelLeave()"
                          >
                            <div
                              style="width: 80%; float: left"
                              class="holder"
                              contenteditable="false"
                              :placeholder="$t('cert.selectTips')"
                            >
                              {{ this.dataForm.classroomLabelName }}
                            </div>
                            <el-link
                              type="primary"
                              :underline="false"
                              class="el-icon-error link-delete-temp"
                              ref="classroomLabelLink"
                              v-show="
                                classroomLabelShowFlg &&
                                dataForm.classroomLabelName != '' &&
                                dataForm.classroomLabelName != null
                              "
                              style="
                                float: right;
                                margin-top: 9px;
                                color: rgba(0, 0, 0, 0.3);
                              "
                              @click="clearclassroomLabelName()"
                            ></el-link>
                          </div>
                        </el-form-item>
                      </el-col>
                      <el-col :span="3" class="query-button">
                        <el-col :span="24">
                          <el-button
                            type="primary"
                            @click="queryClassroomInfo()"
                            >{{ $t("query") }}</el-button
                          >
                        </el-col>
                      </el-col>
                    </el-row>
                    <el-row :gutter="0">
                      <el-col :span="7">
                        <!--所属城市-->
                        <el-form-item
                          :label="$t('res.courseclassroomrela.city')"
                          class="twoPopupCity"
                          prop="cityList"
                        >
                          <class-tree
                            ref="cityclassRef"
                            v-on:getSelectList="getCitySelectList"
                            v-bind:defaultProps="citydefaultProps"
                            v-bind:isOpen="false"
                            v-bind:url="queryCityTreeUrl"
                            v-bind:isSelect="false"
                          ></class-tree>
                        </el-form-item>
                      </el-col>
                      <!--所属场地-->
                      <el-col :span="7">
                        <el-form-item class="twoPopupCity">
                          <span slot="label">
                            <el-link
                              type="primary"
                              :underline="false"
                              slot="reference"
                              @click.native.prevent="showSuboSiteDlg"
                              >{{
                                $t("res.courseclassroomrela.classification")
                              }}</el-link
                            >
                          </span>
                          <div
                            class="el-input el-input--default el-input__inner"
                            style="height: 30px"
                            @mouseenter="templateNameLinkShow()"
                            @mouseleave="templateNameLinkLeave()"
                          >
                            <div
                              style="width: 80%; float: left"
                              class="holder"
                              contenteditable="false"
                              :placeholder="$t('cert.selectTips')"
                            >
                              {{ this.dataForm.subordinateSiteName }}
                            </div>
                            <el-link
                              type="primary"
                              :underline="false"
                              class="el-icon-error link-delete-temp"
                              ref="templateNameLink"
                              v-show="
                                templateNameLinkShowFlg &&
                                dataForm.subordinateSiteName != '' &&
                                dataForm.subordinateSiteName != null
                              "
                              style="
                                float: right;
                                margin-top: 9px;
                                color: rgba(0, 0, 0, 0.3);
                              "
                              @click="clearTemplateName()"
                            ></el-link>
                          </div>
                        </el-form-item>
                      </el-col>
                      <el-col :span="7"
                        >&nbsp;
                        <!-- 教室状态 -->
                      </el-col>
                      <el-col :span="3" class="query-button">
                        <el-col :span="24">
                          <el-button
                            class="el-back M-margin-l"
                            type="info"
                            @click="resetQuery()"
                            >{{ $t("reset") }}</el-button
                          >
                        </el-col>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </el-col>
            </el-row>
            <!-- 数据网格 -->
            <div class="dataBox">
              <el-table
                border
                ref="selectClassroominfo"
                :data="dataList"
                v-loading="dataListLoading"
                size="mini"
                stripe
                @select="selectRedio"
                @select-all="selectAllRedio"
              >
                <el-table-column
                  type="selection"
                  header-align="center"
                  align="center"
                  width="50"
                >
                </el-table-column>
                <el-table-column
                  prop="xh"
                  fixed
                  :label="$t('res.courseclassroomrela.serialNo')"
                  type="index"
                  min-width="55"
                  header-align="center"
                  align="center"
                />
                <!-- 教室id -->
                <el-table-column
                  prop="classroomId"
                  header-align="center"
                  v-if="false"
                  align="center"
                  :label="$t('res.courseclassroomrela.classroomNo')"
                >
                </el-table-column>
                <!-- 教室编号 -->
                <el-table-column
                  prop="classroomNo"
                  header-align="center"
                  align="center"
                  width="100"
                  show-overflow-tooltip
                  :label="$t('res.courseclassroomrela.classroomNo')"
                >
                </el-table-column>
                <!-- 教室名称 -->
                <el-table-column
                  prop="classroomName"
                  header-align="center"
                  align="center"
                  :width="160"
                  show-overflow-tooltip
                  :label="$t('res.courseclassroomrela.classroomName')"
                >
                </el-table-column>
                <!-- 教室分类 -->
                <el-table-column
                  prop="classroomClass"
                  header-align="center"
                  align="center"
                  show-overflow-tooltip
                  :label="$t('res.courseclassroomrela.classroomClass')"
                >
                </el-table-column>
                <!-- 所属城市 -->
                <el-table-column
                  prop="city"
                  header-align="center"
                  align="center"
                  show-overflow-tooltip
                  :label="$t('res.courseclassroomrela.city')"
                >
                </el-table-column>
                <!-- 所属场地 -->
                <el-table-column
                  prop="classification"
                  header-align="center"
                  align="center"
                  show-overflow-tooltip
                  :label="$t('res.courseclassroomrela.classification')"
                >
                </el-table-column>
                <!-- 教室状态 -->
                <!-- 教室标签 -->
                <el-table-column
                  prop="classroomTag"
                  header-align="center"
                  align="center"
                  show-overflow-tooltip
                  :label="$t('res.courseclassroomrela.classroomTag')"
                >
                  <template slot-scope="scope">
                    <span
                      class="el-dropdown-link"
                      v-if="scope.row.numberLaber !== null"
                      @click="checkLable(scope.row)"
                      >{{ $t("view") }}</span
                    >
                  </template>
                </el-table-column>
                <!-- 年份 -->
                <el-table-column
                  prop="annual"
                  header-align="center"
                  align="center"
                  show-overflow-tooltip
                  :label="$t('res.courseclassroomrela.annual')"
                >
                </el-table-column>
                <!-- 年度目标 -->
                <el-table-column
                  prop="reportAnnualTarget"
                  header-align="center"
                  align="center"
                  show-overflow-tooltip
                  :label="$t('res.courseclassroomrela.reportAnnualTarget')"
                >
                </el-table-column>
                <!-- 面积 -->
                <el-table-column
                  prop="roomArea"
                  header-align="center"
                  align="center"
                  show-overflow-tooltip
                  :label="$t('res.courseclassroomrela.roomArea')"
                >
                </el-table-column>
                <!-- 人数 -->
                <el-table-column
                  prop="maxNo"
                  header-align="center"
                  align="center"
                  show-overflow-tooltip
                  :label="$t('res.courseclassroomrela.maxNo')"
                >
                </el-table-column>
                <!-- 楼层 -->
                <el-table-column
                  prop="floor"
                  header-align="center"
                  align="center"
                  show-overflow-tooltip
                  :label="$t('res.courseclassroomrela.floor')"
                >
                </el-table-column>
                <!-- 举升机数量 -->
                <el-table-column
                  prop="liftNo"
                  header-align="center"
                  align="center"
                  :width="85"
                  show-overflow-tooltip
                  :label="$t('res.courseclassroomrela.liftNo')"
                >
                </el-table-column>
                <!-- 工位数量 -->
                <el-table-column
                  prop="workplaceNo"
                  header-align="center"
                  align="center"
                  :width="120"
                  show-overflow-tooltip
                  :label="$t('res.courseclassroomrela.workplaceNo')"
                >
                </el-table-column>
              </el-table>
              <el-pagination
                @size-change="pageSizeChangeHandle"
                @current-change="pageCurrentChangeHandle"
                :current-page="page"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
              >
              </el-pagination>
            </div>
          </el-card>
        </el-col>
        <!--已选教室-->
        <el-col :span="6">
          <el-card class="box-card">
            <div>
              <span class="dataBox" style="display:block; margin-bottom: 10px">{{
                $t("res.courseclassroomrela.selected")
              }}</span>
              <div>
                <el-row :gutter="10">
                  <el-col v-for="tag in classroomData" :key="tag.classroomNo" style="overflow: hidden">
                    <el-tag
                      style="margin-bottom: 10px; width: 100%"
                      :key="tag.classroomNo"
                      @close="handleClose(tag)"
                      closable
                      >{{ tag.classroomNo }}</el-tag
                    >
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-card>
          <div style="text-align: right; margin-top: 12px">
            <el-button size="mini" type="primary" @click="closeSuboTrainerDlg"
              >取 消</el-button
            >
            <el-button size="mini" type="primary" @click="onOk"
              >确 定</el-button
            >
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 所属场地dialog -->
    <subordinate-site
      ref="suborSiteRef"
      :isSingleElection="false"
      :isShow="false"
      :isQueryShow="true"
      v-bind:selectTable="selectSite"
      v-bind:statusList="statusList"
      :dialogVisible="isShowSuboSite"
      v-on:closeSuboSiteDlg="closeSuboSiteDlg"
      v-on:bringBack="bringBack"
    ></subordinate-site>
    <!--标签查询条件-->
    <el-dialog
      title="选择标签"
      :visible="isQueryShowLable"
      width="70%"
      append-to-body
      :before-close="showQueryLableClose"
    >
      <el-form label-position="top" label-width="150px" :ref="dataForm">
        <div>
          <el-row>
            <el-col :span="24">
              <el-form-item prop="tagName" style="width: 100% !important">
                <tag
                  :checkedList="checkList"
                  :moduleId="moduleId"
                  :overLabelShow="true"
                  :closeShow="true"
                  :bussinessTypeId="bussinessTypeId"
                  :brandCode="bussinessTypeChecked"
                  @getBussinessType="getBussinessType"
                  @changeCheckedList="changeCheckedList"
                  ref="tagTree"
                  @fatherMethod="fatherMethod"
                ></tag>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div>
        <el-button type="primary" @click="onOkLable">{{
          $t("res.rela.determine")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 标签查看 -->
    <el-dialog
      title="标签查看"
      :visible="isShowLable"
      width="70%"
      append-to-body
      :before-close="showLableClose"
    >
      <el-form label-position="top" label-width="150px" :ref="dataForm">
        <div>
          <el-row>
            <el-col :span="24">
              <el-form-item prop="tagName" style="width: 100% !important">
                <tag
                  :checkedList="showcheckList"
                  :moduleId="moduleId"
                  :overLabelShow="false"
                  :closeShow="false"
                  :bussinessTypeId="bussinessTypeId"
                  :brandCode="bussinessTypeChecked"
                  @getBussinessType="getBussinessType"
                  @changeCheckedList="changeShowCheckedList"
                  ref="tagTree"
                  @fatherMethod="fatherMethod"
                ></tag>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import mixinViewModule from "@/mixins/view-module";
import ClassTree from "@/components/rm/class-tree/index";
import subordinateSite from "@/components/rm/subordinateSite-calendar/index";
import Tag from "@/components/rm/label-select/index";
import VueI18n from "@/i18n";
import Vue from "vue";
export default {
  props: {
    classroomInfoList: {
      type: Array,
      required: false,
    },
    classroomList: {
      type: Array,
      required: false,
    },
    isSelectElection: {
      type: Boolean,
      default: false,
    },
    selectTable: {
      type: Array,
      required: false,
    },
  },
  mixins: [mixinViewModule],
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: "/rm/courseclassroomrela/queryClassroomlist",
        getDataListIsPage: true,
        deleteURL: "/rm/courseclassroomrela/delete",
        deleteIsBatch: true,
        exportURL: "/rm/courseclassroomrela/export",
      },
      dataForm: {
        classroomNo: "",
        classRoomStatus: "",
        classroomLabel: "",
        classroomLabelName: "",
        classroomClassList: [],
        cityList: [],
        classificationList: [],
      },
      dataForms: {
        priority: "",
      },
      dataFormHold: {
        classRoomStatusArr: [],
        classificationListArr: [],
      },
      isQueryShowLable: false,
      isShowLable: false,
      checkList: [],
      showcheckList: [],
      // 模块id，20 代表组织管理模块
      moduleId: "20",
      bussinessTypeId: 10,
      bussinessTypeChecked: 10,
      isShowSuboSite: false,
      selectSite: [],
      statusList: ["10"],
      // 已选教室
      classroomData: [],
      classroomInfo: {},
      statusArr: this.enums["status"], // 状态下拉框
      priorityArr: this.enums["priority"], // 优先级
      siteInfoArr: [
        { code: "112", name: "东莞庆宝" },
        { code: "113", name: "艾仕得成都培训中心" },
        { code: "114", name: "东营广宝" },
        { code: "115", name: "北京培训中心（新）" },
        { code: "116", name: "郑州培训基地" },
        { code: "117", name: "测试场地001" },
      ], // 所属场地
      dataListLoading: false,
      // 教室分类
      classroomProps: {
        children: "children",
        label: "roomClassCnName",
      },
      queryclassroomUrl: "/rm/courseclassroomrela/courseClassroomTreeRela",
      // 城市分类
      citydefaultProps: {
        children: "childrenRegionList",
        label: "regionNameCn",
      },
      queryCityTreeUrl: "/rm/courseclassroomrela/queryregiontree",
      // 标签树
      commLabelProps: {
        children: "children",
        label: "labelNameCn",
      },
      querycommLabelUrl: "/rm/courseclassroomrela/queryCommLabelNodeByNameRela",
      // 场地分类
      // classificationProps: {
      //   children: 'children',
      //   label: 'siteClassCnName'
      // },
      // queryClassificationTreeUrl: '/rm/siteclass/list',
      // 编辑面板标签对齐方式
      labelPosition: "left",
      // 查询面板标签宽度
      queryLabelWidth: "auto",
      classroomLabelList: [], // 标签,
      templateNameLinkShowFlg: false,
      classroomLabelShowFlg: false,
      dataRule: {
        priority: [
          {
            required: true,
            message: this.$t("res.courseclassroomrela.priorityCheck"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  components: {
    Tag,
    "class-tree": ClassTree,
    "subordinate-site": subordinateSite,
  },
  mounted() {
    this.initMethods();
  },
  methods: {
    // 点击选择标签打开弹窗
    showSuboLableDlg() {
      this.isQueryShowLable = true;
    },
    //关闭选择标签弹窗
    showQueryLableClose() {
      this.isQueryShowLable = false;
    },
    changeCheckedList(array) {
      this.checkList = array;
    },
    onOkLable() {
      let args = this.checkList;
      if (args && args !== "" && args.length > 0) {
        let classLabelinfo = [];
        let classLabelinfoName = [];
        args.forEach(function (item) {
          classLabelinfo.push(item.labelId);
          classLabelinfoName.push(item.labelName);
        });
        this.dataForm.classroomLabel = classLabelinfo.join(",");
        this.dataForm.classroomLabelName = classLabelinfoName.join(",");
      } else {
        this.dataForm.classroomLabel = "";
        this.dataForm.classroomLabelName = "";
      }
      this.isQueryShowLable = false;
    },
    // 获取数据列表
    getDataList() {
      let newDataForm = JSON.parse(JSON.stringify(this.dataForm));
      if ("regionIds" in newDataForm) {
        if (newDataForm.regionIds.length === 0) {
          newDataForm.regionIds = "";
        } else {
          newDataForm.regionIds = newDataForm.regionIds.join(",");
        }
      }
      this.dataListLoading = true;
      this.$request
        .get(this.mixinViewModuleOptions.getDataListURL, {
          order: this.order,
          orderField: this.orderField,
          page: this.mixinViewModuleOptions.getDataListIsPage
            ? this.page
            : null,
          limit: this.mixinViewModuleOptions.getDataListIsPage
            ? this.limit
            : null,
          ...newDataForm,
        })
        .then((res, total, code, data) => {
          console.log(res);
          this.dataListLoading = false;
          let resultList = data.data.records;
          this.dataList = resultList;
          this.total = this.mixinViewModuleOptions.getDataListIsPage
            ? parseInt(data.data.total, 10)
            : 0;
          // 延迟加载
          this.$nextTick(() => {
            this.querSelect();
          });
        })
        .catch(() => {
          this.dataListLoading = false;
        });
    },
    // 状态转换
    statusFormatter(row) {
      return Vue.filter("coverEnum")(row.classStatus, "status");
    },
    initMethods() {
      this.$refs.tagTree && this.$refs.tagTree.isReset();
      this.classroomData = [];
      if (this.classroomList && this.classroomList.length > 0) {
        this.classroomData = JSON.parse(JSON.stringify(this.classroomList));
      }
      this.dataForm = {
        classroomNo: "",
        classRoomStatus: "10",
        classroomLabel: "",
        classroomClassList: "",
        cityList: "",
        classificationList: "",
      };
      this.dataForms = {
        priority: "",
      };
      this.dataFormHold = {
        classRoomStatusArr: [],
      };
      this.$refs.classroomclassRef.resetChecked();
      this.$refs.cityclassRef.resetChecked();
      this.page = 1;
      this.getDataList();
      this.checkList = [];
      this.selectSite = [];
      this.templateNameLinkShowFlg = false;
      this.classroomLabelShowFlg = false;
      this.$request
        .get(`/rm/courseclassroomrela/queryBussinessTypeIdRela`)
        .then((res, total, code, data) => {
          if (data.data != null && data.data != undefined) {
            this.bussinessTypeId = data.data;
            this.bussinessTypeChecked = data.data;
          }
        });
    },
    selectRedio: function selectRedio(selection, row) {
      let result = [];
      for (let a = 0; a < selection.length; a++) {
        if (row.classroomNo === selection[a].classroomNo) {
          result.push(row);
          break;
        }
      }
      if (result.length > 0) {
        if (
          this.isSelectElection &&
          this.$refs.selectClassroominfo.selection.length > 1
        ) {
          this.$refs.selectClassroominfo.clearSelection(); // 清空
          this.classroomData = [];
          this.classroomData.push(row);
          this.$refs.selectClassroominfo.toggleRowSelection(row); // 选择当前行
        } else {
          if (row) {
            this.classroomData.push(row);
          }
        }
      } else {
        if (
          this.isSelectElection &&
          this.$refs.selectClassroominfo.selection.length > 1
        ) {
          this.$refs.selectClassroominfo.clearSelection(); // 清空
          this.classroomData = [];
        } else {
          for (let b = 0; b < this.classroomData.length; b++) {
            if (row.classroomNo === this.classroomData[b].classroomNo) {
              this.classroomData.splice(b, 1);
              break;
            }
          }
        }
      }
    },
    // 控制可选项
    checkboxT(row, index) {
      let _this = this;
      let checkFlg = 1;
      if (_this.classroomInfoList && _this.classroomInfoList.length > 0) {
        _this.classroomInfoList.forEach(function (item) {
          if (row.classroomNo === item.classroomNo) {
            checkFlg = 0;
          }
        });
      }
      return checkFlg;
    },
    // 全选
    selectAllRedio(selection) {
      let _this = this;
      if (selection) {
        let classroomDataB = [];
        if (_this.classroomData && _this.classroomData.length > 0) {
          _this.classroomData.forEach(function (item) {
            classroomDataB.push(item);
          });
        }
        if (selection.length > 0) {
          for (var i = 0; i < selection.length; i++) {
            let hasFlg = false;
            if (classroomDataB && classroomDataB.length > 0) {
              for (var l = 0; l < classroomDataB.length; l++) {
                if (
                  classroomDataB[l].classroomNo === selection[i].classroomNo
                ) {
                  hasFlg = true;
                }
              }
            }
            if (!hasFlg) {
              _this.classroomData.push(selection[i]);
            }
          }
        } else {
          _this.classroomData = [];
          if (classroomDataB && classroomDataB.length > 0) {
            for (var j = 0; j < classroomDataB.length; j++) {
              let hasFlg = false;
              for (var k = 0; k < _this.dataList.length; k++) {
                if (
                  classroomDataB[j].classroomNo ===
                  _this.dataList[k].classroomNo
                ) {
                  hasFlg = true;
                }
              }
              if (!hasFlg) {
                _this.classroomData.push(classroomDataB[j]);
              }
            }
          }
        }
      }
    },
    // 确认
    onOk: function () {
      let _this = this;
      _this.$emit("onOk", _this.classroomData);
      _this.$refs.selectClassroominfo.clearSelection();
    },
    closeSuboTrainerDlg: function () {
      this.classroomData = [];
      this.$emit("closeSubClassroomDlg");
    },
    // 重置查询条件
    resetQuery() {
      this.selectSite = [];
      this.dataForm = {
        classroomNo: "",
        classRoomStatus: "10",
        classroomLabel: "",
        classroomLabelName: "",
        classroomClassList: "",
        cityList: "",
        classificationList: "",
      };
      this.dataFormHold = {
        classRoomStatusArr: [],
        classificationListArr: [],
      };
      this.$refs.classroomclassRef.resetChecked();
      this.$refs.cityclassRef.resetChecked();
      this.checkList = [];
      this.classroomData = [];
      this.$refs.tagTree && this.$refs.tagTree.isReset();
      this.queryClassroomInfo();
    },
    getClassroomList(args) {
      let classroominfo = [];
      args.forEach(function (item) {
        classroominfo.push(item.id);
      });
      this.dataForm.classroomClassList = classroominfo.join(",");
    },
    getCitySelectList(args) {
      if (args && args !== "" && args.length > 0) {
        let citySelect = [];
        args.forEach(function (item) {
          citySelect.push(item.id);
        });
        this.dataForm.cityList = citySelect.join(",");
      } else {
        this.dataForm.cityList = "";
      }
    },
    getClassificationList(args) {
      if (args && args !== "" && args.length > 0) {
        let siteClass = [];
        args.forEach(function (item) {
          siteClass.push(item.id);
        });
        this.dataForm.siteClassList = siteClass.join(",");
      } else {
        this.dataForm.siteClassList = "";
      }
    },
    // 双击选择教室数据
    onDbClassroom(val) {
      if (val) {
        if (this.classroomData) {
          for (var i = 0; i < this.classroomData.length; i++) {
            if (
              String(this.classroomData[i].classroomId) ===
              String(val.classroomId)
            ) {
              this.$message.warning(this.$t("res.courseclassroomrela.ondb"));
              return false;
            }
          }
        }
        this.classroomData.push(val);
      }
    },
    // 打开页面时，回填勾选
    querSelect() {
      // debugger
      if (this.classroomData && this.classroomData.length > 0) {
        var map = new Map();
        this.classroomData.forEach(function (item, index) {
          map.set(item.classroomNo, item);
        });
        let _this = this;
        _this.dataList.forEach(function (dataitem, dataindex) {
          if (map.has(dataitem.classroomNo)) {
            _this.$refs.selectClassroominfo.toggleRowSelection(dataitem);
          }
        });
      }
    },
    // 删除已选备件
    handleClose(data) {
      for (let a = 0; a < this.dataList.length; a++) {
        if (data.classroomNo === this.dataList[a].classroomNo) {
          this.$refs.selectClassroominfo.toggleRowSelection(
            this.dataList[a],
            false
          ); // 选择当前行
          break;
        }
      }
      this.classroomData.splice(this.classroomData.indexOf(data), 1);
    },
    queryClassroomInfo() {
      this.page = 1;
      this.getDataList();
    },
    // 关闭所属场地
    closeSuboSiteDlg() {
      this.isShowSuboSite = false;
    },
    // 点击所属场地确定带回
    // 点击所属场地确定带回
    bringBack(selection) {
      let siteNames = [];
      let siteIds = [];
      let siteClassNameCns = [];
      let cityNames = [];
      let cityIds = [];
      let siteCodes = [];
      selection.forEach((item) => {
        siteNames.push(item.siteCnName);
        siteIds.push(item.id);
        siteClassNameCns.push(item.siteClassCnName);
        cityNames.push(item.cityName);
        cityIds.push(item.cityId);
        siteCodes.push(item.siteNo);
      });
      if (selection && selection.length > 0) {
        this.dataForm.classificationList = siteIds.join(",");
        this.dataForm.subordinateSiteName = siteNames.join(",");
      } else {
        this.dataForm.classificationList = "";
        this.dataForm.subordinateSiteName = "";
      }
      this.isShowSuboSite = false;
      this.selectSite = selection;
    },
    celarSiteName() {
      this.selectSite = [];
      this.dataForm.classificationList = "";
      this.dataForm.subordinateSiteName = "";
    },
    // 点击所属场地打开弹窗
    showSuboSiteDlg() {
      this.isShowSuboSite = true;
      this.$refs.suborSiteRef.initSuborSite();
    },
    // 获取教室标签
    getClassroomLabelList(args) {
      if (args && args !== "" && args.length > 0) {
        let classroomLabelinfo = [];
        args.forEach(function (item) {
          classroomLabelinfo.push(item.id);
        });
        this.dataForm.classroomLabel = classroomLabelinfo.join(",");
      } else {
        this.dataForm.classroomLabel = "";
      }
    },
    clearSuboSiteDlg() {
      this.dataForm.classificationList = "";
    },
    clearTemplateName() {
      this.selectTable = [];
      this.dataForm.classificationList = "";
      this.dataForm.subordinateSiteName = "";
      this.templateNameLinkShowFlg = false;
    },
    templateNameLinkShow() {
      this.templateNameLinkShowFlg = true;
    },
    templateNameLinkLeave() {
      this.templateNameLinkShowFlg = false;
    },
    checkLable(row) {
      this.isShowLable = true;
      this.$request
        .get(
          `/rm/courseclassroomrela/queryCheckedCommLabel/${row.classroomId}/${this.bussinessTypeId}`
        )
        .then((data) => {
          // 已选择的标签
          this.showcheckList = data ? data : [];
          // 特殊情况，自己国际化
          const language = VueI18n.locale;
          if (language === "zh-CN") {
            this.showcheckList.forEach((o) => {
              o.labelName = o.labelNameCn;
            });
          } else {
            this.showcheckList.forEach((o) => {
              o.labelName = o.labelNameEn;
            });
          }
        });
    },
    showLableClose() {
      this.showcheckList = [];
      this.isShowLable = false;
    },
    clearclassroomLabelName() {
      this.dataForm.classroomLabel = "";
      this.dataForm.classroomLabelName = "";
      this.checkList = [];
      this.classroomLabelShowFlg = false;
    },
    classroomLabelShow() {
      this.classroomLabelShowFlg = true;
    },
    classroomLabelLeave() {
      this.classroomLabelShowFlg = false;
    },
    getBussinessType(val) {
      this.bussinessTypeId = val;
    },
    changeShowCheckedList(array) {
      this.showcheckList = array;
    },
    // 重新勾选业务标签
    fatherMethod() {
      // this.checkList = []
      // 已选择的标签
      // this.checkList = this.dataForm.commLabelVoList ? this.dataForm.commLabelVoList : []
      // 特殊情况，自己国际化
      const language = VueI18n.locale;
      if (language === "zh-CN") {
        this.checkList.forEach((o) => {
          o.labelName = o.labelNameCn;
        });
      } else {
        this.checkList.forEach((o) => {
          o.labelName = o.labelNameEn;
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.mod-rm__courseclassroomrela {
  .query-button {
    text-align: right;
  }
  .el-form-item {
    width: 100% !important;
    max-width: 280px !important;
    line-height: 32px !important;
    padding-right: 10px;
    .el-form-item__label {
      height: 32px !important;
    }
  }
}
.location-layout22 .el-input {
  width: 80px !important;
}
.location-layout22 .el-input__inner {
  width: 80px !important;
}
.link-delete-temp:hover {
  cursor: pointer;
  text-decoration: none !important;
}
.holder:empty::before {
  color: #bbb;
  content: attr(placeholder);
}

.traninerPool-search-condition .el-form-item__content {
  margin-left: 110px !important;
}
.oneBoxTrainer .el-form-item__label-wrap {
  margin-left: 28px !important;
}
.oneBoxTrainerLabel .el-form-item__label-wrap {
  margin-left: 28px !important;
}
/* .oneClassificationTrainersCol .el-form-item__content {
  margin-left: 110px !important;
} */
.oneClassificationTrainersCol .el-form-label-wrap {
  margin-left: 28px !important;
}
/* .oneClassificationTrainersCol .el-form-item {
  width: 95% !important;
} */
.twoPopupCity .el-form-item__label-wrap {
  margin-left: 28px !important;
}
</style>
